import { useCallback } from "react";
var getAbsoluteXPosition = function (align, targetRect, dropRect) {
    if (align.left === "left")
        return targetRect.left;
    if (align.left === "right")
        return targetRect.right;
    if (align.right === "right")
        return targetRect.right - dropRect.width;
    if (align.right === "left")
        return targetRect.left - dropRect.width;
    return targetRect.left + targetRect.width / 2 - dropRect.width / 2;
};
var reverseXPosition = function (align) {
    if (align.left === "left")
        return { right: "right" };
    if (align.left === "right")
        return { right: "left" };
    if (align.right === "right")
        return { left: "left" };
    if (align.right === "left")
        return { left: "right" };
};
var getXPostition = function (align, targetRect, dropRect, canHideTarget) {
    if (canHideTarget === void 0) { canHideTarget = true; }
    var x = getAbsoluteXPosition(align, targetRect, dropRect);
    var minX = Math.max(0, x);
    x = Math.min(window.innerWidth - dropRect.width, minX);
    if (!canHideTarget && minX !== x)
        return getXPostition(reverseXPosition(align), targetRect, dropRect);
    return x;
};
var getAbsoluteYPosition = function (align, targetRect, dropRect) {
    if (align.top === "top")
        return targetRect.top;
    if (align.top === "bottom")
        return targetRect.bottom;
    if (align.bottom === "bottom")
        return targetRect.bottom - dropRect.height;
    if (align.bottom === "top")
        return targetRect.top - dropRect.height;
    return targetRect.top + targetRect.height / 2 - dropRect.height / 2;
};
var reverseYPosition = function (align) {
    if (align.top === "top")
        return { bottom: "bottom" };
    if (align.top === "bottom")
        return { bottom: "top" };
    if (align.bottom === "bottom")
        return { top: "top" };
    if (align.bottom === "top")
        return { top: "bottom" };
};
var getYPosition = function (align, targetRect, dropRect, canHideTarget) {
    if (canHideTarget === void 0) { canHideTarget = true; }
    var y = getAbsoluteYPosition(align, targetRect, dropRect);
    var minY = Math.max(0, y);
    y = Math.min(window.innerHeight - dropRect.height, minY);
    if (!canHideTarget && minY !== y)
        return getYPosition(reverseYPosition(align), targetRect, dropRect);
    return y;
};
var getWidth = function (stretch, targetRect, dropRect) {
    if (stretch === "align")
        return Math.min(targetRect.width, dropRect.width);
    if (stretch === "width")
        return Math.max(targetRect.width, dropRect.width);
    return Math.min(dropRect.width, window.innerWidth);
};
var styles = ["top", "right", "bottom", "right", "width"];
export default (function (target, dropRef, align, stretch, canHideTarget) {
    return useCallback(function () {
        if (!dropRef.current)
            return;
        styles.forEach(function (position) { return (dropRef.current.style[position] = ""); });
        var targetRect = target.getBoundingClientRect();
        var dropRect = dropRef.current.getBoundingClientRect();
        var width = getWidth(stretch, targetRect, dropRect);
        dropRect.width = width;
        var x = getXPostition(align, targetRect, dropRect, canHideTarget);
        var y = getYPosition(align, targetRect, dropRect, canHideTarget);
        dropRef.current.style.left = x + "px";
        dropRef.current.style.top = y + "px";
        if (stretch) {
            dropRef.current.style.width = width + "px";
        }
    }, [target, align, stretch]);
});
